import axios from 'axios';

const getAvailability = (companyId, params) =>
  axios.post(`/interconnectivity/${companyId}/data${params}`);

const getAvailabilityExport = (companyId, params) =>
  axios.post(`/interconnectivity/${companyId}/export${params}`);

const getInterconnectivity = (companyId, params) =>
  axios.get(`/interconnectivity/${companyId}/export${params}`, {
    responseType: 'blob',
  });

export default {
  getAvailability,
  getAvailabilityExport,
  getInterconnectivity,
};
